import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const PlayerLayout = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      {/* Player Navbar */}
      {/* <nav className="bg-slate-900/80 backdrop-blur-md border-b border-slate-700/50 px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-8">
            <Link to="/player/dashboard" className="text-2xl font-bold text-white">JUCO</Link>
            <div className="flex gap-6">
              <Link to="/player/dashboard" className="text-gray-300 hover:text-white transition-colors text-sm uppercase tracking-wide">DASHBOARD</Link>
              <Link to="/player/profile" className="text-gray-300 hover:text-white transition-colors text-sm uppercase tracking-wide">PROFILE</Link>
              <Link to="/player/messages" className="text-gray-300 hover:text-white transition-colors text-sm uppercase tracking-wide">MESSAGES</Link>
              <Link to="/player/recruiting" className="text-gray-300 hover:text-white transition-colors text-sm uppercase tracking-wide">RECRUITING</Link>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-gray-400 bg-blue-600/20 px-3 py-1 rounded-full border border-blue-500/30">Player</span>
            <button className="text-white hover:text-cyan-400 transition-colors">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
            </button>
            <button className="text-white hover:text-cyan-400 transition-colors">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </button>
          </div>
        </div>
      </nav> */}

      {/* Page Content */}
      <Outlet />
    </div>
  );
};

export { PlayerLayout };
export default PlayerLayout;
